import {USER_TYPES, UserTypeOption} from '../../onboardingWizardStore';

export type UserTypeInfo = {
  id: UserTypeOption;
  title: string;
};

const userTypeMap = {
  [USER_TYPES.PRIVATE_USER]: {
    id: USER_TYPES.PRIVATE_USER,
    title: 'Personal use',
  },
  [USER_TYPES.SMALL_MEDIUM_BUSINESS]: {
    id: USER_TYPES.SMALL_MEDIUM_BUSINESS,
    title: 'Small/medium business',
  },
  [USER_TYPES.LARGE_ENTERPRISE]: {
    id: USER_TYPES.LARGE_ENTERPRISE,
    title: 'Large company (100+ employees)',
  },
};

export default function getUserTypeInfo(
  userType: UserTypeOption
): UserTypeInfo {
  return userTypeMap[userType];
}
